import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES, IMAGES } from "../mock";
import Seo from "../components/Seo";

const Services = () => {
  return (
    <div className="bg-[#0E0E0F] text-[#EDE3CB]">
      <Seo
        path="/services"
        title="The Prop Department"
        description="The prop department, led by a Los Angeles Property Master: department leadership, prop fabrication, 3D printing and scanning, period research, archival recreation, and a 48' property trailer with full kit."
      />
      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMAGES.workshop2} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0E0E0F]/85 to-[#0E0E0F]" />
        </div>
        <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12 pt-24 pb-20">
          <div className="section-label">The Prop Department</div>
          <h1 className="font-display text-6xl md:text-8xl mt-4 leading-[0.9]">What is a <span className="brass-text">prop</span>?</h1>
          <p className="font-serif-accent italic text-xl md:text-2xl text-[#EDE3CB]/80 max-w-2xl mt-6 leading-snug">
            "A prop is anything any other department forgets on the day."
            <span className="block mt-3 not-italic font-sans text-xs tracking-[0.28em] uppercase text-[#B8935A]/85">— Sean Mannion</span>
          </p>
        </div>
      </section>

      {/* Why props matter header */}
      <section className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-8 pb-10">
        <div className="section-label">Watch</div>
        <h2 className="font-display text-6xl md:text-8xl mt-4 leading-[0.9]">Why props <span className="brass-text">matter</span>.</h2>
      </section>

      {/* Video reel */}
      <section className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-4 pb-20">
        <div className="relative w-full aspect-video bg-[#0B0B0C] border border-[#B8935A]/25 overflow-hidden shadow-[0_30px_70px_-30px_rgba(0,0,0,0.9)]">
          <iframe
            src="https://www.youtube.com/embed/I4XDvZKntpA?rel=0"
            title="Jesse J. Adams — Property Master Reel"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="absolute inset-0 w-full h-full"
          />
        </div>
      </section>

      {/* What I bring header */}
      <section className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-8 pb-12">
        <div className="section-label">The Prop Department</div>
        <h2 className="font-display text-6xl md:text-8xl mt-4 leading-[0.9]">What I <span className="brass-text">bring</span>.</h2>
        <p className="text-[#EDE3CB]/75 max-w-2xl mt-6 text-lg">
          Practical, production-ready support across the full lifecycle of the property department — from prep to wrap.
        </p>
      </section>

      {/* Services grid */}
      <section className="max-w-[1440px] mx-auto px-6 lg:px-12 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {SERVICES.map((s) => (
            <div key={s.group} className="bg-[#0E0E0F] p-8">
              <div className="font-display text-2xl tracking-wide">{s.group}</div>
              <div className="brass-divider mt-4 opacity-40" />
              <ul className="mt-5 space-y-2.5">
                {s.items.map((it) => (
                  <li key={it} className="flex items-start gap-3 text-[15px] text-[#EDE3CB]/80">
                    <Check size={14} className="text-[#B8935A] mt-1.5 shrink-0" strokeWidth={2.5} />
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-[1440px] mx-auto px-6 lg:px-12 pb-28">
        <div className="border border-[#B8935A]/30 p-10 md:p-16 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div>
            <div className="section-label">Inquiries</div>
            <h3 className="font-display text-4xl md:text-5xl mt-3 leading-tight">Working a project that needs <span className="brass-text">a Property Master</span>?</h3>
          </div>
          <div className="flex flex-wrap gap-3 md:justify-end">
            <Link to="/contact" className="btn-primary">Check Availability <ArrowUpRight size={14} /></Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
